export enum Teams {
    SEO = 'seo',
}

export enum Features {
    GlobalNav = 'global_nav',
}

export enum Components {
    GlobalNavSearchBar = 'global_nav_search_bar',
    GlobalNavLogo = 'global_nav_logo',
    GlobalNavLink = 'global_nav_link',
    GlobalNavDesktopDropdown = 'global_nav_desktop_dropdown',
    GlobalNavMobileDropdown = 'global_nav_mobile_dropdown',
    GlobalNavDropdown = 'global_nav_dropdown',
    GlobalNavNestedDropdown = 'global_nav_nested_dropdown',
    GlobalNavSecondaryDropdown = 'global_nav_secondary_dropdown',
    GlobalNavSimpleDropdown = 'global_nav_simple_dropdown',
}

export enum Actions {
    Start = 'start',
    ChooseFile = 'choose_file',
    Submit = 'submit',
    Create = 'create',
    Manage = 'manage',
    Click = 'click',
    Subscribe = 'click_subscribe',
    Select = 'select',
    Deselect = 'deselect',
}
